import { Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import FlexContainer from "../../components/containers/FlexContainer";
import PrivacyPolicyCheckbox from "../../components/fields/PrivacyPolicyCheckbox/PrivacyPolicyCheckbox";
import PasswordFields from "../../domains/person/components/PasswordFields";
import { useSetPassword } from "../../domains/session/services/sessionServices";
import { useLangLabels } from "../../shared/lang/services/useLangLabels";
import { USER_ROUTES } from "../../shared/routes/routes";
import LoginFormContainer from "./components/LoginFormContainer";

const ActivateAccountPage: React.FC<{}> = () => {
  const { lang } = useLangLabels();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { mutate, status } = useSetPassword();

  const [acceptedPrivacyPolicy, setAcceptedPrivacyPolicy] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = (password: string) => {
    if (!token || !acceptedPrivacyPolicy) return;
    mutate({ token, newPassword: password }, { onSuccess: () => setDone(true) });
  };

  return (
    <LoginFormContainer size="md">
      <FlexContainer flexDirection="column" gap="16px" align="center" padding="0px 16px 16px">
        <Typography variant="h6" align="left" style={{ width: "100%" }}>
          {lang.activateAccount.title}
        </Typography>

        {!token ? (
          <Alert style={{ width: "100%", boxSizing: "border-box" }} severity="error">
            {lang.activateAccount.missingToken}
          </Alert>
        ) : done ? (
          <>
            <Alert style={{ width: "100%", boxSizing: "border-box" }} severity="success">
              {lang.activateAccount.successMessage}
            </Alert>
            <Link to={`/${USER_ROUTES.login}`}>{lang.activateAccount.goToLogin}</Link>
          </>
        ) : (
          <PasswordFields
            mode="new"
            onSave={handleSubmit}
            saveStatus={status === "loading" ? "loading" : undefined}
            saveLabel={lang.activateAccount.submitButton}
            saveStyleProps={{ height: "40px" }}
            saveDisabled={!acceptedPrivacyPolicy}
          >
            <PrivacyPolicyCheckbox
              checked={acceptedPrivacyPolicy}
              onChange={setAcceptedPrivacyPolicy}
              disabled={status === "loading"}
            />
            {status === "error" ? (
              <Alert style={{ width: "100%", boxSizing: "border-box" }} severity="error">
                {lang.activateAccount.errorMessage}
              </Alert>
            ) : null}
          </PasswordFields>
        )}
      </FlexContainer>
    </LoginFormContainer>
  );
};

export default ActivateAccountPage;
